import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { ConfigurationApi, DocumentTypes, GovernanceDocumentRequestTypeMappingDTO } from "../core/api.gen";
import { DialogService } from "../core/dialog.service";
import { LoaderService } from "../core/loader.service";
import { ToastService } from "../core";

@Component({
  selector: "eos-governance-doc-mapping",
  templateUrl: "./governance-doc-mapping.component.html",
  styleUrls: ["./governance-doc-mapping.component.css"],
})
export class GovernanceDocMappingComponent implements OnInit {
  allActivities: GovernanceDocumentRequestTypeMappingDTO[] = [];
  activities: GovernanceDocumentRequestTypeMappingDTO[] = [];
  documentTypes: DocumentTypes[] = [];

  filterForm = new UntypedFormGroup({
    documentTypeId: new UntypedFormControl(null),
  });

  constructor(
    private loader: LoaderService,
    private dialogService: DialogService,
    private toast: ToastService,
    private configApi: ConfigurationApi
  ) {}

  ngOnInit() {
    this.loader.show();
    this.configApi
      .getDocumentTypes()
      .pipe(finalize(() => this.loader.clear()))
      .subscribe((types) => {
        this.documentTypes = types;
        this.getMappings();
      });
  }

  getMappings() {
    this.loader.show();
    this.configApi
      .getGovernanceDocumentRequestTypeMappings()
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(
        (result) => {
          this.allActivities = result;
          this.applyFilter();
        },
        () => this.toast.error("Error loading mappings, please try again!")
      );
  }

  applyFilter() {
    const documentTypeId = this.filterForm.value.documentTypeId;
    this.activities = documentTypeId
      ? this.allActivities.filter(a => a.documentTypeId === documentTypeId)
      : this.allActivities;
  }

  clearFilter() {
    this.filterForm.reset();
    this.activities = this.allActivities;
  }

  createActivity() {
    this.dialogService
      .showGovernanceDocMappingEdit(undefined, this.documentTypes, false)
      .result.then((result) => {
        if (result === "success") this.getMappings();
      });
  }

  editActivity(id: number) {
    this.loader.show();
    this.configApi
      .getGovernanceDocumentRequestTypeMappingById(id)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(
        (activity) => {
          this.dialogService
            .showGovernanceDocMappingEdit(activity, this.documentTypes, true)
            .result.then((result) => {
              if (result === "success") this.getMappings();
            });
        },
        () => this.toast.error("Error loading mapping, please try again!")
      );
  }
}